export enum ForcingCode {
  ForcedAfterIssuerResponse = 'FORCED_AFTER_ISSUER_RESPONSE',
  ForcedBeforeAuthRequest = 'FORCED_BEFORE_AUTH_REQUEST',
  ManualAuthEntry = 'MANUAL_AUTH_ENTRY',
  NoForcing = 'NO_FORCING',
}
